module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_04_6DE79_1SF_HXR.0940c995.jpg";